'use client';

import FormText from '@/components/form/FormText/FormText';
import FaIcon, { faSearch } from '@/components/icon/FaIcon/FaIcon';
import PageHeader from '@/components/layouts/PageHeader/PageHeader';
import utilsStyles from '@/styles/modules/utils.module.scss';
import type { Route } from 'next';
import { useRouter } from 'next/navigation';
import { useForm } from 'react-hook-form';
import type { Keyword } from '../../types';
import styles from './LotteryListHeader.module.scss';

function LotteryListHeader({
  query,
}: {
  query?: string;
  keywords: Array<Keyword>;
  activeKeywordId?: number;
}) {
  const router = useRouter();
  const { handleSubmit, getValues, control } = useForm({
    mode: 'onChange',
    defaultValues: {
      searchText: query || '',
    },
  });

  const textSearch = () => {
    const params = new URLSearchParams(location.search);
    if (getValues('searchText').length > 0) {
      params.set('q', getValues('searchText'));
    } else {
      params.delete('q');
    }
    router.replace(`${location.pathname}?${params.toString()}` as Route);
  };

  const onChangeText = () => {
    textSearch();
  };

  const submitText = async () => {
    textSearch();
  };

  return (
    <>
      <div className={styles.header}>
        <PageHeader text='オンラインくじ一覧' />
        <div className={styles.textSearchWrapper}>
          <form onSubmit={handleSubmit(submitText)}>
            <FormText
              name='searchText'
              control={control}
              outlined
              placeholder='イベント名を検索できます'
              prefix={
                <div className={styles.searchIcon}>
                  <FaIcon icon={faSearch} size='xl' />
                </div>
              }
              onChange={onChangeText}
              isSmall={true}
            />
          </form>
        </div>
      </div>

      <div className={styles.searchArea}>
        {query && (
          <div className={utilsStyles.mtXSmall}>
            <p className={`${utilsStyles.textSmall} ${utilsStyles.textBold}`}>"{query}"の検索結果</p>
          </div>
        )}
      </div>
    </>
  );
}

export default LotteryListHeader;
